import { jsx as _jsx } from "react/jsx-runtime";
export const PlainLink = ({ href, children, ...rest }) => (_jsx("a", { href: href, ...rest, children: children }));
export function cx(...names) {
    return names.filter(Boolean).join(" ");
}
